module.exports = __webpack_public_path__ + "img/省医院.3621161.png";